module.exports = __webpack_public_path__ + "img/SaudiArabia.7932a983.png";